/* eslint-disable max-len */
import React from 'react';
import styled from 'styled-components';

type Props = {
  className?: string;
};
const StyledSVG = styled.svg`
  .cls-1 {
    fill: ${(props) => props.theme.palette.common.white};
  }
  height: 100%;
`;

const SVG = ({ className }: Props) => (
  <StyledSVG
    id='Ebene_1'
    data-name='Ebene 1'
    xmlns='http://www.w3.org/2000/svg'
    viewBox='0 0 206.42 63.88'
    className={className}
  >
    <g id='Page-1'>
      <g id='TLKEnergy' data-name='TLKEnergy'>
        <path
          id='Fill-1'
          className='cls-1'
          d='M9.05.12h2.33A9.59,9.59,0,0,1,21,9.71L21,37.18c0,1.5.06,7.13.81,9a8.39,8.39,0,0,0,5.1,4.93V64c-6.7-.4-12.45-5-15.34-11.57a28.21,28.21,0,0,1-2.19-9.74,10.13,10.13,0,0,0-.56-2.5A9.63,9.63,0,0,0,0,34.45V21.65a19.39,19.39,0,0,1,9.1,2.27l0-23.8Zm20.1,0h2.33a9.59,9.59,0,0,1,9.59,9.59l.06,27.47c0,1.5.06,7.13.8,9A8.41,8.41,0,0,0,47,51.08V64c-6.7-.4-12.45-5-15.34-11.57-2-4.34-2.18-8.92-2.45-14-.05-.8-.1-38.32-.1-38.32Zm20.36,0h2.32a9.59,9.59,0,0,1,9.6,9.59l0,13.63a13.53,13.53,0,0,1,6.88-1.89,20.16,20.16,0,0,1,2.46.11V34.21l-1.08,0c-4.45,0-8.06,2.66-8.06,8.63,0,6.24,4.71,8.62,8.06,8.62h1.35l0,12.46c-.59.07-2.17.1-2.78.1-7.07,0-13.2-4.66-16.25-11.49-2-4.45-2.22-9-2.49-14.07,0-.8-.1-38.32-.1-38.32Z'
          transform='translate(0 -0.12)'
        />
        <path
          id='TLK-ENERGY'
          className='cls-1'
          d='M90.39,34.62H79.75v2.6h3.8V50.51h3V37.22h3.65a16.12,16.12,0,0,0,.24-2.6ZM102.08,47.9h-6V34.62h-3V50.51h8.77a18.75,18.75,0,0,0,.21-2.61Zm14.69-13.14a19.94,19.94,0,0,0-3.09-.28L108,41.63h-.14v-7H105V50.51h2.9v-5l1.55-1.84,4.63,7a17.37,17.37,0,0,0,3.06-.29c-1.93-3.23-3.79-6.06-5.87-8.89Zm17.35,13.16h-6.55V43.61H132V41.06h-4.41V37.22h5.94a19.37,19.37,0,0,0,.21-2.6h-9.1V50.51h9.27a19.9,19.9,0,0,0,.23-2.59Zm15.33-13.3h-2.64V44a17.18,17.18,0,0,0,.12,1.91l-.21,0a11.33,11.33,0,0,0-.76-1.79l-5.45-9.57a23.38,23.38,0,0,0-3.06.21V50.51h2.64V40.59c0-.5-.05-1.18-.12-1.84l.21,0a12.34,12.34,0,0,0,.76,1.8l5.75,10.11a21,21,0,0,0,2.76-.21Zm13.87,13.3h-6.56V43.61h4.41V41.06h-4.41V37.22h5.94a19.37,19.37,0,0,0,.21-2.6h-9.1V50.51h9.27a20,20,0,0,0,.24-2.59ZM178,50.35l-1.72-3.51a11.21,11.21,0,0,0-2.5-3.47,4.38,4.38,0,0,0,3-4.24c0-3.38-2.41-4.67-5.28-4.67a38.59,38.59,0,0,0-4.93.33V50.51h2.88V44.24h1.84a17.8,17.8,0,0,1,2.4,3.92l1.18,2.5a16.86,16.86,0,0,0,3.09-.31Zm-4.15-11A2.44,2.44,0,0,1,171.12,42h-1.6V36.93c.54,0,1.25-.09,1.88-.09a2.2,2.2,0,0,1,2.48,2.47Zm18.06,10.38V42.1H186.4a14.66,14.66,0,0,0,.23,2.52H189v3.25a7.11,7.11,0,0,1-2.08.29c-2.45,0-3.86-1.49-3.86-5.5,0-4.55,1.6-5.68,4.19-5.68a9.1,9.1,0,0,1,3.87.85,16,16,0,0,0,.47-2.69,12.86,12.86,0,0,0-4.5-.75c-4.2,0-7.19,2.45-7.19,8.15,0,5.31,2.36,8.21,7,8.21a12.52,12.52,0,0,0,5-1.06Zm14.48-14.93a17.18,17.18,0,0,0-2.81-.26l-2.62,6c-.18.44-.33.92-.47,1.34h-.19a10,10,0,0,0-.44-1.3L197.2,34.5a21.08,21.08,0,0,0-3.07.26,107.17,107.17,0,0,0,4.67,9.93v5.82h2.95V44.69a107.5,107.5,0,0,0,4.67-9.93Z'
          transform='translate(0 -0.12)'
        />
      </g>
    </g>
  </StyledSVG>
);

export default styled(SVG)`` as any;
export const TlkEnergyGrey: any = styled(SVG)`
  .cls-1 {
    fill: ${(props) => props.theme.palette.primary.contrastTextDisabled};
  }
`;
